/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from './..\\..\\..\\com\\atproto\\label\\defs.defs.js'
import * as RepoStrongRef from './..\\..\\..\\com\\atproto\\repo\\strongRef.defs.js'

const $nsid = 'app.bsky.actor.profile'

type $nsid = typeof $nsid

export { $nsid }

/** A declaration of a Bluesky account profile. */
type Main = {
  $type: 'app.bsky.actor.profile'

  /**
   * Small image to be displayed next to posts from account. AKA, 'profile picture'
   */
  avatar?: l.BlobRef

  /**
   * Larger horizontal image to display behind profile view.
   */
  banner?: l.BlobRef

  /**
   * Self-label values, specific to the Bluesky application, on the overall account.
   */
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject
  website?: l.UriString

  /**
   * Free-form pronouns text.
   */
  pronouns?: string
  createdAt?: l.DatetimeString
  pinnedPost?: RepoStrongRef.Main

  /**
   * Free-form profile description text.
   */
  description?: string
  displayName?: string
  joinedViaStarterPack?: RepoStrongRef.Main
}

export type { Main }

/** A declaration of a Bluesky account profile. */
const main = /*#__PURE__*/ l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  /*#__PURE__*/ l.object({
    avatar: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.blob({
        accept: ['image/png', 'image/jpeg'],
        maxSize: 1000000,
      }),
    ),
    banner: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.blob({
        accept: ['image/png', 'image/jpeg'],
        maxSize: 1000000,
      }),
    ),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<LabelDefs.SelfLabels>(
            (() => LabelDefs.selfLabels) as any,
          ),
        ],
        false,
      ),
    ),
    website: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri' }),
    ),
    pronouns: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 200, maxGraphemes: 20 }),
    ),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    pinnedPost: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
    ),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 2560, maxGraphemes: 256 }),
    ),
    displayName: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 640, maxGraphemes: 64 }),
    ),
    joinedViaStarterPack: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
    ),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
